export default __webpack_public_path__ + "static/media/4.89d98ff5.png";